var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNewBirthdays = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85.95 92.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc466;}.cls-2{fill:#2e63f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.91,
    y: 34.7,
    width: 18.03,
    height: 15.98,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.18,
    y: 34.7,
    width: 18.03,
    height: 15.98,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.18,
    y: 58.4,
    width: 18.03,
    height: 15.98,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.91,
    y: 58.4,
    width: 18.03,
    height: 15.98,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.65,8.39H24.29a.79.79,0,0,1,0-1.57H61.65a.79.79,0,0,1,0,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.62,93H20.79C12.11,93,0,84.29,0,70.12V13.34A6.44,6.44,0,0,1,6.33,6.82h11a.78.78,0,0,1,0,1.56h-11a4.88,4.88,0,0,0-4.77,5V70.12c0,13.2,11.2,21.31,19.23,21.31H79.62a4.86,4.86,0,0,0,4.76-5V13.34a4.86,4.86,0,0,0-4.76-4.95h-11a.79.79,0,0,1,0-1.57h11A6.44,6.44,0,0,1,86,13.34V86.48A6.43,6.43,0,0,1,79.62,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,92.47a.78.78,0,0,1-.78-.78V78.42a4.7,4.7,0,0,0-4.6-4.79H1.88a.78.78,0,1,1,0-1.56H13.63a6.26,6.26,0,0,1,6.16,6.35V91.69A.78.78,0,0,1,19,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.79,17a4.34,4.34,0,0,1-4.28-4.4V4.4a4.28,4.28,0,1,1,8.56,0v8.19A4.34,4.34,0,0,1,20.79,17Zm0-15.43A2.78,2.78,0,0,0,18.07,4.4v8.19a2.72,2.72,0,1,0,5.44,0V4.4A2.78,2.78,0,0,0,20.79,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.15,17a4.34,4.34,0,0,1-4.28-4.4V4.4a4.28,4.28,0,1,1,8.56,0v8.19A4.34,4.34,0,0,1,65.15,17Zm0-15.43A2.78,2.78,0,0,0,62.43,4.4v8.19a2.72,2.72,0,1,0,5.44,0V4.4A2.78,2.78,0,0,0,65.15,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.78,49.78V37.53a3.23,3.23,0,0,0-3.23-3.23h-.67c.8-1.22.34-2.67,0-3.66-.16-.49-.37-1.17-.25-1.37,1-1.69,1.8-3.45,1.09-4.86-.49-1-1.56-1.52-3.27-1.71-4.08-.43-9.53,4.17-11.33,5.81a2.26,2.26,0,0,0-1.61-.57,4.43,4.43,0,0,0-1.79.47,4,4,0,0,1-1.72.45,4.18,4.18,0,0,1-1.73-.45,4.38,4.38,0,0,0-1.78-.47,2.37,2.37,0,0,0-1.6.54c-1.82-1.65-7.23-6.19-11.29-5.78-1.72.19-2.79.75-3.28,1.71-.71,1.41.11,3.17,1.1,4.86.12.2-.1.88-.25,1.37-.32,1-.78,2.44,0,3.66H23.5a3.23,3.23,0,0,0-3.22,3.23V49.81a3,3,0,0,0-1.35,2.7v4a3,3,0,0,0,1.35,2.7V71.52a3.22,3.22,0,0,0,3.22,3.22H38.64a3.18,3.18,0,0,0,2.37.94h4a3.16,3.16,0,0,0,2.37-.94H62.55a3.23,3.23,0,0,0,3.23-3.22V59.26a3,3,0,0,0,1.34-2.72v-4A3,3,0,0,0,65.78,49.78Zm-.22,6.76c0,.68-.18,1.49-1.06,1.49H48.1V51H64.5c.88,0,1.06.81,1.06,1.5ZM21.6,58c-1,0-1.11-1.05-1.11-1.5v-4c0-.45.11-1.5,1.11-1.5H38v7Zm24.94.78h0V73a1,1,0,0,1-.1.46c-.28.45-1.11.49-1.4.49H41c-.29,0-1.12,0-1.39-.49a1,1,0,0,1-.1-.46V58.81h0V35.72c0-.82,1.24-.87,1.49-.87h4c.25,0,1.5,0,1.5.87ZM64.22,37.53V49.45H48.1V35.86H62.55A1.67,1.67,0,0,1,64.22,37.53ZM59.31,24.26c.78.08,1.76.3,2,.86.42.84-.61,2.61-1,3.36a3.2,3.2,0,0,0,.11,2.63c.51,1.6.69,2.48-1.07,3.19H49.22V32.88a11.31,11.31,0,0,0-.28-3C51,28,56.07,23.9,59.31,24.26ZM39.52,29.5a3.06,3.06,0,0,1,1.16.34,5,5,0,0,0,4.69,0,3.1,3.1,0,0,1,1.17-.34c.77,0,1.12.49,1.12,3.38V34.3H47.6a3.23,3.23,0,0,0-2.56-1H41a3.25,3.25,0,0,0-2.56,1H38.4V32.88C38.4,30,38.74,29.5,39.52,29.5ZM25.68,31.11a3.2,3.2,0,0,0,.12-2.63c-.45-.75-1.48-2.52-1.05-3.36.28-.56,1.27-.78,2-.86C30,23.91,35,27.92,37.12,29.87a11.5,11.5,0,0,0-.28,3V34.3H26.76C25,33.59,25.18,32.71,25.68,31.11ZM23.5,35.86H38V49.45H21.84V37.53A1.66,1.66,0,0,1,23.5,35.86ZM21.84,71.52V59.59H38V73.11s0,0,0,.07H23.5A1.66,1.66,0,0,1,21.84,71.52Zm40.71,1.66H48.09s0,0,0-.07V59.59H64.22V71.52A1.67,1.67,0,0,1,62.55,73.18Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewBirthdays, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newBirthdays.ea8faabd.svg";
export { ForwardRef as ReactComponent };